import { render, staticRenderFns } from "./secondLevelOrderNxshenpi.vue?vue&type=template&id=639b10cf&scoped=true"
import script from "./secondLevelOrderNxshenpi.vue?vue&type=script&lang=js"
export * from "./secondLevelOrderNxshenpi.vue?vue&type=script&lang=js"
import style0 from "./secondLevelOrderNxshenpi.vue?vue&type=style&index=0&id=639b10cf&prod&scoped=true&lang=css"
import style1 from "./secondLevelOrderNxshenpi.vue?vue&type=style&index=1&id=639b10cf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639b10cf",
  null
  
)

export default component.exports